import {
  Divider,
  DownloadLink,
  MainHeading,
  PolicyPageWrapper,
  TableTextContent,
  TitleTextContent,
} from '@rimactechnology/rimac-ui-lib';
import { Fragment } from 'react';

import { PrivacyPolicyPoliciesDynamicZone } from '@/api';

interface Props {
  // the dynamicZone type is same for all policies
  data: PrivacyPolicyPoliciesDynamicZone[];
}

export default function EnhancedPolicyPageWrapper({ data }: Props) {
  return (
    <PolicyPageWrapper>
      <Fragment>
        {data?.map((policy, index) => {
          switch (policy?.__typename) {
            case 'ComponentPoliciesMainHeading':
              return (
                <MainHeading
                  key={`componentPoliciesMainHeading-${index}`}
                  useCase="group"
                  richText={policy.text}
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDownloadLink':
              return (
                <DownloadLink
                  key={`componentPoliciesDownloadLink-${index}`}
                  label={policy.label || ''}
                  href={policy.link || ''}
                  useCase="group"
                />
              );
            case 'ComponentPoliciesTableTextContent':
              return (
                <TableTextContent
                  key={`componentPoliciesTableTextContent-${index}`}
                  useCase="group"
                  text={policy.richText}
                  parentIndex={index}
                  tableData={{
                    headings: (policy.tableHead || []).map(
                      (heading) => heading?.headingItem || '',
                    ),
                    values: (policy.tableRow?.table_rows?.data || []).map(
                      (row) =>
                        (row.attributes?.rows || []).map(
                          (item) => item?.item || '',
                        ),
                    ),
                  }}
                />
              );
            case 'ComponentPoliciesTitleTextContent':
              return (
                <TitleTextContent
                  key={`componentPoliciesTitleTextContent-${index}`}
                  richText={policy.text}
                  useCase="group"
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDevider':
              return <Divider key={`componentPoliciesDevider-${index}`} />;
          }
        })}
      </Fragment>
    </PolicyPageWrapper>
  );
}
